import React from 'react';
import { Group, Rect, Text } from 'react-konva';
import {
  ROLES_CHIP_FILL,
  ROLES_CHIP_FONT_SIZE,
  ROLES_CHIP_HEIGHT,
  ROLES_CHIP_INSET,
  ROLES_CHIP_STROKE,
  ROLES_CHIP_TEXT,
  extraRoleCount,
  rolesChipLabel,
  rolesChipWidth,
} from '../models/personRoles';

interface OrgRolesChipProps {
  attrs: Readonly<Record<string, unknown>>;
  cardWidth: number;
  /** Corner away from the avatar; the name line gives up this width. */
  corner?: 'right' | 'left';
  fontFamily?: string;
}

/**
 * "+N roles" pill for a person who holds more than one seat. The tree places
 * the person once, at their primary seat; the chip says the card is standing
 * in for more, and the properties panel lists the seats.
 */
export const OrgRolesChip: React.FC<OrgRolesChipProps> = ({
  attrs,
  cardWidth,
  corner = 'right',
  fontFamily = 'Inter, system-ui, sans-serif',
}) => {
  const extra = extraRoleCount(attrs);
  if (extra === 0) return null;
  const width = rolesChipWidth(extra);
  const x = corner === 'right' ? cardWidth - ROLES_CHIP_INSET - width : ROLES_CHIP_INSET;
  return (
    <Group x={x} y={ROLES_CHIP_INSET} listening={false} name="org-roles-chip">
      <Rect
        width={width}
        height={ROLES_CHIP_HEIGHT}
        cornerRadius={ROLES_CHIP_HEIGHT / 2}
        fill={ROLES_CHIP_FILL}
        stroke={ROLES_CHIP_STROKE}
        strokeWidth={1}
      />
      <Text
        width={width}
        height={ROLES_CHIP_HEIGHT}
        text={rolesChipLabel(extra)}
        fontSize={ROLES_CHIP_FONT_SIZE}
        fontFamily={fontFamily}
        fontStyle="600"
        fill={ROLES_CHIP_TEXT}
        align="center"
        verticalAlign="middle"
      />
    </Group>
  );
};
